/* eslint-disable @typescript-eslint/explicit-function-return-type */

import { Dispatch } from '@reduxjs/toolkit';

export const defaultExecute = (
    action: any,
    emit: (arg0: any, arg1: any) => void,
    next: (arg0: any) => any,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    dispatch: any
) => {
    // eslint-disable-line no-unused-vars
    emit('worker-msg', { ...action });
    return next(action);
};

export const defaultBroadcast = (
    action: any,
    emit: (arg0: any, arg1: any) => void,
    next: (arg0: any) => any,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    dispatch: any
) => {
    // eslint-disable-line no-unused-vars
    emit('broadcast-msg', { ...action });
    return next(action);
};
const evaluate = (
    action: { type: any },
    option: any[] | ((type: any, action: any) => boolean) | string
) => {
    if (!action || !action.type) {
        return false;
    }

    const { type } = action;
    let matched = false;
    if (typeof option === 'function') {
        // Test function
        matched = option(type, action);
    } else if (typeof option === 'string') {
        // String prefix
        matched = type.indexOf(option) === 0;
    } else if (Array.isArray(option)) {
        // Array of types
        matched = option.some((item) => type.indexOf(item) === 0);
    }
    return matched;
};
const evaluateBroadcast = (
    action: { type: any },
    option: any[] | ((type: any, action: any) => boolean) | string
) => {
    if (!action || !action.type) {
        return false;
    }

    const { type } = action;
    let matched = false;
    if (typeof option === 'function') {
        // Test function
        matched = option(type, action);
    } else if (typeof option === 'string') {
        // String prefix
        matched = type.indexOf(option) === 0;
    } else if (Array.isArray(option)) {
        // Array of types
        matched = option.some(
            (item) => type.indexOf(item) === 0 && item === 'BROADCAST_'
        );
    }
    return matched;
};
/**
 * Allows you to register actions that when dispatched, send the action to the
 * server via a service worker
 */
export default function createSocketIoMiddleware(
    Worky: any,
    criteria: any[] | string | ((type: any, action: any) => boolean),
    {
        eventName,
        execute = defaultExecute,
        executeBroadcast = defaultBroadcast,
    }: {
        eventName?: string | string[];
        execute?: any;
        executeBroadcast?: any;
    } = {}
) {
    const ws2 = Worky;

    const emitBound = ws2.emit.bind(ws2);
    return ({ dispatch }: { dispatch: Dispatch; getState: VoidFunction }) => {
        if (typeof eventName !== 'undefined') {
            // Wire socket.io to dispatch actions sent by the server.
            if (typeof eventName === 'string') {
                ws2.on(eventName, dispatch);
            } else if (Array.isArray(eventName) === true) {
                // ws2.on("action", dispatch);
                eventName.forEach((element) => {
                    ws2.on(element, dispatch);
                });
            }
        }

        return (next: (arg0: any) => any) => (action: any) => {
            if (evaluate(action, criteria)) {
                if (evaluateBroadcast(action, criteria)) {
                    return executeBroadcast(
                        { ...action },
                        emitBound,
                        next,
                        dispatch
                    );
                }
                return execute({ ...action }, emitBound, next, dispatch);
            }

            return next(action);
        };
    };
}
